import React, { Component } from "react";

class Counter extends Component {
  render() {
    const { allowEdit, onIncrement, onDecrement, value } = this.props;

    return (
      <div>
        <span className="m-2 score">{value}</span>
        {allowEdit && (
          <div>
            <button
              onClick={onIncrement}
              className="btn btn-primary m-2 counter-button"
            >
              +
            </button>
            <button
              onClick={onDecrement}
              className="btn btn-primary m-2 counter-button"
              disabled={value === 0}
            >
              -
            </button>
          </div>
        )}
      </div>
    );
  }
}

export default Counter;



// WEBPACK FOOTER //
// ./src/components/counter.jsx